"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.progressCircleComponentStyles = void 0;
const lit_1 = require("lit");
exports.progressCircleComponentStyles = (0, lit_1.css) `
    .circular-progress-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        top: 40%;
        position: relative;
    }
    .circular-progress-label {
        margin-top: 10px;
        font-size: 20px;
        white-space: nowrap;
    }
`;
